import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import HttpApi  from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import tEn from './en/en.json';
import tFr from './fr/fr.json';

const availableLang=['en','fr'];
const option={
  order:['navigator','htmlTag','path','subdomail'],
  checkWhiteList:true
}
i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(HttpApi )
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    lng: 'fr',
    fallbackLng: 'fr',
    whitelist:availableLang,
    detection:option,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        en: {
            translation: tEn
        },
        fr: {
            translation: tFr
        },
    },
  });

  //i18n.changeLanguage('fr');


export default i18n;